module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/search-42d0e448ea2e340f369bed873ff2ea3a.svg&quot;;"